import React, { useEffect, useRef, useState } from "react";
import { InputComponent } from "../InputComponent";
import { AccordianComponent } from "../AccordianComponent";
import CutsomColorPickerComp from "../CutsomColorPickerComp";
import ImageUploadComponent from "../ImageUploadComp";
import { useLocation } from "react-router-dom";
import ToggleButton from "./QRToggleButton";
import { PreviewFrame, TopPreviewHeader } from "../SVGIcon";
import { QRPreviewGallery } from "./QRPreviewAll";
import ImageUploadMultipleComponent from "../ImageUploadMultipleComponent";
import { useDispatch } from "react-redux";
import { deleteField } from "../../redux/slice/qrSlice";
import ViewPreviewModal from "../Modal/QR/ViewPreviewModal";
import { MdErrorOutline } from "react-icons/md";
import ColorPickerComponent from "../ColorPicker";

const colors = [
  { id: "black", background: "#e0201c", button: "#000000" },
  { id: "green", background: "#e8fce8", button: "#0e8b70" },
  { id: "yellow", background: "#fff9cc", button: "#998600" },
  { id: "red", background: "#fecdd6", button: "#b00223" },
];
const GALLERY = ({ localQrData, setLocalQrData, errors, setErrors }) => {
  const [showModalPreview, setShowModalPreview] = useState(false);
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState("Preview Page");
  const handleToggle = (option) => {
    setSelectedOption(option);
  };

  const location = useLocation();

  useEffect(() => {
    if (location.state?.qrData) {
      const qrDataFromLocation = location.state.qrData.data;
      setLocalQrData(qrDataFromLocation);

      if (qrDataFromLocation?.color) {
        setLocalQrData((prevQrData) => ({
          ...prevQrData,
          color: qrDataFromLocation?.color,
        }));
      }
    }
  }, [location.state, setLocalQrData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalQrData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const hasExecutedRef = useRef(false);
  // console.log("hashhh", hasExecutedRef);
  const handleImageUpload = (mediaData, name, file) => {
    // setLocalQrData((prevData) => ({
    //   ...prevData,
    //   [name]: file,
    // }));

    if (localQrData?.id && !hasExecutedRef.current) {
      dispatch(deleteField(name));
      setLocalQrData((prevData) => ({
        ...prevData,
        gallery_image: [],
      }));

      hasExecutedRef.current = true;
    }

    setLocalQrData((prevData) => {
      // Check if `gallery_image` already exists and is an array
      const existingFiles = prevData[name] || [];

      // Append the new file to the existing array of files
      return {
        ...prevData,
        [name]: [...existingFiles, file],
      };
    });
  };

  const handleImageDelete = (fieldName, imageIndex) => {
    // console.log("All images deleted");
    setLocalQrData((prevData) => ({
      ...prevData,
      [fieldName]: prevData[fieldName].filter(
        (_, index) => index !== imageIndex
      ),
    }));
  };

  const handleTextColorChange = (field, value) => {
    setLocalQrData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  console.log("localQrDatalocalQrDatalocalQrData", localQrData);
  return (
    <>
      <div className="gallery-page">
        <button
          className="viewPreviewbtn"
          onClick={() => setShowModalPreview(true)}
        >
          View Preview
        </button>
        <div className="containerr">
          <div className="left">
            <AccordianComponent title={"Enter the name of your QR code"}>
              <InputComponent
                placeholder="e.g My QR code"
                onChange={handleInputChange}
                name="qr_name"
                value={localQrData.qr_name}
              />
            </AccordianComponent>
            <AccordianComponent title={"Choose your design"}>
              <CutsomColorPickerComp
                colors={colors}
                qrData={localQrData}
                setQrData={setLocalQrData}
              />

              <div
                className="color-picker-con mt-5"
                style={{
                  backgroundColor: "#f2f2f2",
                  padding: "1rem",
                  borderRadius: "0.5rem",
                }}
              >
                <ColorPickerComponent
                  label=" Text Color"
                  color={localQrData.text_color}
                  setColor={(color) =>
                    handleTextColorChange("text_color", color)
                  }
                />
                <ColorPickerComponent
                  label="Button Text Color"
                  color={localQrData.button_color}
                  setColor={(color) =>
                    handleTextColorChange("button_color", color)
                  }
                />
              </div>
            </AccordianComponent>
            <AccordianComponent title={"Add images"}>
              <div className="wrapper-img-upload-dashed">
                <ImageUploadMultipleComponent
                  // defaultImage={"/assets/images/default-img.png"}
                  onImageUpload={handleImageUpload}
                  onImageDelete={handleImageDelete}
                  label="Upload Image"
                  name="gallery_image"
                  localQrData={localQrData}
                />
              </div>

              {errors?.gallery_image && (
                <div className="error-message">
                  <MdErrorOutline className="error-icon" />
                  {errors.gallery_image}
                </div>
              )}
            </AccordianComponent>
            <AccordianComponent
              title={"Information about your images' gallery"}
            >
              <InputComponent
                label={"Image/photo/album title"}
                name={"gallery_title"}
                placeholder={"e.g. Our wedding album"}
                onChange={handleInputChange}
                value={localQrData?.gallery_title}
                textColorStyle={{ color: localQrData?.text_color }}
              />
              <InputComponent
                label={"Description"}
                name={"gallery_description"}
                placeholder={"e.g. Professional photos from our wedding day"}
                onChange={handleInputChange}
                value={localQrData?.gallery_description}
                textColorStyle={{ color: localQrData?.text_color }}
              />
              <InputComponent
                label={"Website"}
                name={"gallery_website"}
                placeholder={"e.g. https://www.ourweddingwebsite.com"}
                onChange={handleInputChange}
                value={localQrData?.gallery_website}
                textColorStyle={{ color: localQrData?.text_color }}
              />
              <div className="wrap-inp-cmp">
                <InputComponent
                  label={"Button text"}
                  name={"gallery_btn_text"}
                  placeholder={"e.g. Write your link text here..."}
                  onChange={handleInputChange}
                  value={localQrData?.gallery_btn_text}
                  textColorStyle={{ color: localQrData?.button_color }}
                />
                <InputComponent
                  label={"URL"}
                  name={"gallery_url"}
                  type="url"
                  placeholder={"e.g. https://..."}
                  onChange={handleInputChange}
                  value={localQrData?.gallery_url}
                  textColorStyle={{ color: localQrData?.text_color }}
                />
              </div>
            </AccordianComponent>
          </div>
          <div className="right">
            <>
              <ToggleButton
                selectedOption={selectedOption}
                onToggle={handleToggle}
              />
              {/* <div className="qr-preview__layout__image">
                <div className="Preview-layout Preview-layout--vcard">
                  <TopPreviewHeader className="topHeaderSvg" />
                  <QRPreviewGallery localQrData={localQrData} />
                </div>
                <PreviewFrame className="preview-frame" />
              </div> */}

              <div className="qr-preview__layout__image">
                <PreviewFrame className="mobileFrameSvg" />
                <div className="Preview-layout Preview-layout--vcard">
                  <QRPreviewGallery localQrData={localQrData} />
                </div>
              </div>
            </>

            {/* <img src="/assets/images/phone-image.png" alt="phone-image" /> */}
          </div>
        </div>
      </div>
      <ViewPreviewModal
        setShowModalPreview={setShowModalPreview}
        showModalPreview={showModalPreview}
        localQrData={localQrData}
        type={"image_gallery"}
      />
    </>
  );
};

export default GALLERY;
